import React, { useState, useRef } from "react";
import { Box, IconButton } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { Flipper } from "react-flip-toolkit";
import DropdownContainer from "../dropdownContainer";

import ChartSettings from "./ChartSettings";
import { useHoverDropdown } from "../dropdownContainer/useHoverDropdown";

const SettingsMenu = () => {
  const duration = 300;
  const { isOpen, animatingOut, onMouseEnter, onMouseLeave } = useHoverDropdown(duration);

  return (
    <Flipper flipKey={isOpen}>
      <Box
        sx={{ position: "relative", display: "inline-block", ml: 1 }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <IconButton sx={{ px: 1, py: 0 }}>
          <SettingsIcon fontSize="large" sx={{ color: "white" }} />
        </IconButton>
        {isOpen && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1,
              mt: "0px",
            }}
          >
            <DropdownContainer animatingOut={animatingOut} duration={duration}>
              <Box sx={{ px: 2, py: 1, width: 125 }}>
                <ChartSettings />
              </Box>
            </DropdownContainer>
          </Box>
        )}
      </Box>
    </Flipper>
  );
};

export default SettingsMenu;